module.exports = __webpack_public_path__ + "img/icon-ticket-lost.fa6ef1dd.svg";